import React from "react";
import Autosuggest from "react-autosuggest";
import classNames from "classnames";
import { searchInputIn } from "../../common/searchTerms";
import UserProvided from "../components/UserProvided";
import { RECOMMENDABLE_TYPE } from "../constants";
import Modal from "../../common/components/Modal";

class InstrumentSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value,
            suggestions: [],
            askingForUserProvidedInstrument: false
        };

        this.version = 0;
        this._handleSuggestionsUpdateRequested = this._handleSuggestionsUpdateRequested.bind(this);
        this._handleInputChange = this._handleInputChange.bind(this);
        this._handleAskUserToProvide = this._handleAskUserToProvide.bind(this);
        this._handleBlur = this._handleBlur.bind(this);
        this._renderSuggestion = this._renderSuggestion.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value,
            suggestions: []
        });
    }

    render() {
        return (
            <div className={ classNames(this.props.className, "x-recommendation-instrument") }>
                {
                    this.state.askingForUserProvidedInstrument ?
                        <div>
                            <Modal onClose={() => this.setState({value: "", askingForUserProvidedInstrument: false})}>
                                <UserProvided onChange={this.props.onChange} />
                            </Modal>
                        </div> :
                        <Autosuggest suggestions={ this.props.allowUserProvided ? this.state.suggestions.concat([{name: "USER_PROVIDED"}]) : this.state.suggestions }
                                     onSuggestionsUpdateRequested={ this._handleSuggestionsUpdateRequested }
                                     renderSuggestion={ this._renderSuggestion }
                                     getSuggestionValue={ suggestion => suggestion.name }
                                     onSuggestionSelected={ (event, {suggestion}) => {
                                        if(suggestion.name === "USER_PROVIDED") {
                                            this._handleAskUserToProvide();
                                        } else {
                                            this.props.onChange(suggestion);
                                        }
                                     }}
                                     inputProps={{
                                         value: this.state.value,
                                         onChange: this._handleInputChange,
                                         onBlur: this._handleBlur,
                                         autoCapitalize: "off",
                                         autoComplete: "off",
                                         autoCorrect: "off",
                                         spellCheck: false
                                     }}
                        />
                }
            </div>
        );
    }

    _handleAskUserToProvide() {
        this.setState({askingForUserProvidedInstrument: true});
    }

    _handleInputChange(event, {newValue, method}) {
        this.setState({
            value: newValue
        });
    }


    _handleSuggestionsUpdateRequested({value, reason}) {
        switch (reason) {
            case "type":
                this.version += 1;
                const version = this.version;
                this.props.searchForInstrument(value, results => {
                    if (version === this.version) {
                        this.setState({
                            suggestions: results
                        });
                    }
                });
                return;
            case "blur":
                this._handleBlur();
                return;
            default:
                return;
        }
    }

    _handleBlur() {
        if (this.state.suggestions.length > 0) {
            const firstSuggestion = this.state.suggestions[0];

            this.props.onChange(firstSuggestion);

            this.setState({
                value: firstSuggestion.name
            })
        }

    }

    _renderSuggestion(suggestion, { value: searchTerm }) {
        if (suggestion.name === "USER_PROVIDED") {
            return <span>Add Missing...</span>;
        }

        switch (suggestion.recommendableType) {
            case RECOMMENDABLE_TYPE.BOND:
                const bondTopLine = toHtmlWithSearchTermsStrong(suggestion["bloomberg_ticker"], searchTerm);
                const bondBottomLine = toHtmlWithSearchTermsStrong(suggestion["isin"], searchTerm);
                return <SearchResult topLine={bondTopLine} bottomLine={bondBottomLine}/>;
            case RECOMMENDABLE_TYPE.EQUITY:
                const equityTopLine = toHtmlWithSearchTermsStrong(suggestion["bloomberg"], searchTerm);
                const equityBottomLine = toHtmlWithSearchTermsStrong(suggestion["name"], searchTerm);
                return <SearchResult topLine={equityTopLine} bottomLine={equityBottomLine}/>;
            case RECOMMENDABLE_TYPE.FX_PAIR:
                const fxPairTopLine = toHtmlWithSearchTermsStrong(suggestion["pair"], searchTerm);
                return <SearchResult topLine={fxPairTopLine}/>;
            case RECOMMENDABLE_TYPE.ISSUER:
                const issuerTopLine = (<span>
                    <span>{toHtmlWithSearchTermsStrong(suggestion["bloomberg_ticker"], searchTerm)}</span>
                    <span>, {toHtmlWithSearchTermsStrong(suggestion["name"], searchTerm)}</span>
                    <span> &lt;issuer&gt;</span>
                </span>);
                return <SearchResult topLine={issuerTopLine}/>;
            case RECOMMENDABLE_TYPE.SOVEREIGNTY:
                const sovereigntyTopLine = (<span>
                    <span>{toHtmlWithSearchTermsStrong(suggestion["ticker"], searchTerm)}</span>
                    <span>, {toHtmlWithSearchTermsStrong(suggestion["name"], searchTerm)}</span>
                    <span> &lt;sovereignty&gt;</span>
                </span>);
                return <SearchResult topLine={sovereigntyTopLine}/>;
            case RECOMMENDABLE_TYPE.INTEREST_RATE_FUTURE:
                const interestRateTopLine = (<span>
                    <span>{toHtmlWithSearchTermsStrong(suggestion["base_bloomberg_ticker"], searchTerm)}</span>
                    <span>, {toHtmlWithSearchTermsStrong(suggestion["name"], searchTerm)}</span>
                    <span> &lt;future&gt;</span>
                </span>);
                const interestRateBottomLine = (<span>
                    <span>{toHtmlWithSearchTermsStrong(suggestion["exchange"], searchTerm)}</span>
                    <span>, {toHtmlWithSearchTermsStrong(suggestion["base_exchange_ticker"], searchTerm)}</span>
                </span>);
                return <SearchResult topLine={interestRateTopLine} bottomLine={interestRateBottomLine}/>;
        }
    }
}
InstrumentSearch.propTypes = {
    onChange: React.PropTypes.func,
    className: React.PropTypes.string,
    renderSuggestion: React.PropTypes.func,
    searchForInstrument: React.PropTypes.func,
    symbolKey: React.PropTypes.string,
    value: React.PropTypes.string
};
InstrumentSearch.defaultProps = {
    value: ""
};

function toHtmlWithSearchTermsStrong(text, searchTerm) {
    const symbol = searchInputIn(text, searchTerm);
    return <span>{symbol.beforeMatch}<strong>{symbol.match}</strong>{symbol.afterMatch}</span>;
}

const SearchResult = (props) => (
    <span className="x-instrument-search-result">
        {props.topLine}<br/>
        { props.bottomLine ? <small className="x-name" style={{ color: '#777' }}>{props.bottomLine}</small> : null }
    </span>
);

export default InstrumentSearch;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/InstrumentSearch.js
 **/